import { createContext } from 'react'

export interface IAdminCanUpdateContext {
  adminCanUpdate: boolean | undefined
}

export const AdminCanUpdateContext = createContext<IAdminCanUpdateContext>({
  adminCanUpdate: undefined,
})
